import { Icon } from './types';

export const ChevronLeft = ({ svgProps, pathProps }: Icon) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="chevron-left"
    {...svgProps}
  >
    <path
      d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59Z"
      fill="currentColor"
      {...pathProps}
    />
  </svg>
);
